import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Calculator({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-3 -3 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M10.26075532 21.0777333c0 .4466667-.35814894.8093334-.80006383.8093334-.44257447 0-.8007234-.3626667-.8007234-.8093334 0-.4466666.35814893-.8093333.8007234-.8093333.44191489 0 .80006383.3626667.80006383.8093333zM10.26075532 27.0028667c0 .4466666-.35814894.8093333-.80006383.8093333-.44257447 0-.8007234-.3626667-.8007234-.8093333 0-.4473334.35814893-.8093334.8007234-.8093334.44191489 0 .80006383.362.80006383.8093334z" />
        <path d="M1.06134043 32.638H31.804766V1.564H1.06134043zM9.46042766 6.37653333v7.18799997M5.90426596 9.97026667h7.11219144M5.90426596 23.8602667h7.11219144M19.8098106 10.0764h7.1121915M20.3695255 21.9755333l5.0292554 5.0833334M20.3695255 27.0588667l5.0292554-5.0833334" />
      </g>
    </svg>
  )
}

Calculator.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
